import { useState } from "react";
import { toast } from "sonner";
import { Loader2, RefreshCw } from "lucide-react";
import { api } from "../lib/api";

export const ContractRereadButton = () => {
  const [st, setSt] = useState(null);
  const poll = () => setTimeout(async () => {
    const s = await api.contractsRereadStatus().catch(() => null);
    if (!s) return;
    setSt(s);
    if (s.running) return poll();
    toast.success(`انتهت القراءة: تصحّح ${s.fixed} عقد، و${s.unchanged} بقي كما هو`);
    if (s.fixed) setTimeout(() => window.location.reload(), 1800);
  }, 3000);
  const start = async () => {
    if (!window.confirm("يعيد النظام قراءة ملفات العقود المنتهية واحد ورا الثاني، ويصحّح تاريخ النهاية لو لقاه بعد التاريخ المحفوظ. تبدأ؟")) return;
    try { const s = await api.contractsReread(); setSt(s); if (s.running) poll(); else toast.info("ما فيه عقود منتهية لها ملف مرفق"); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر البدء"); }
  };
  const run = st?.running;
  return (
    <button type="button" onClick={start} disabled={run} data-testid="contract-reread-btn"
      className="mr-auto flex items-center gap-1 rounded-full border border-blue-200 bg-blue-50 px-2.5 py-0.5 text-[11px] font-bold text-blue-700 transition-colors hover:bg-blue-100 disabled:opacity-70">
      {run ? <Loader2 className="h-3 w-3 animate-spin" /> : <RefreshCw className="h-3 w-3" />}
      {run ? `جارٍ القراءة ${st.done}/${st.total}` : "إعادة قراءة تواريخ العقود"}
    </button>
  );
};
